import React, { Component } from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class CurrentPriority extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        const { TicketState } = this.props;
        const ticketStatusCount = TicketState;
        return (
            <>
                <div className="col-xl-5 col-lg-5 col-md-5">
                    <div className="card">
                        <div className="Over_all_table_style card-body">
                            <div className="card-header"><h3 className="card-title">PRIORITY-WISE TICKETS DATA </h3></div>
                            <table className="table card-table">
                                <tbody>
                                    <tr>
                                        <td>
                                            <strong className='table_text_left1'>{ticketStatusCount.highCount}</strong>
                                        </td>
                                        <td className="text-right">
                                            <small className="text-muted table_text_left1" style={{ fontSize: "14px", fontWeight: "bold" }}>High</small>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <strong className='table_text_left1'>{ticketStatusCount.mediumCount}</strong>
                                        </td>
                                        <td className="text-right">
                                            <small className="text-muted table_text_left1" style={{ fontSize: "14px", fontWeight: "bold" }}>Medium</small>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <strong className='table_text_left1'>{ticketStatusCount.lowCount}</strong>
                                        </td>
                                        <td className="text-right">
                                            <small className="text-muted table_text_left1" style={{ fontSize: "14px", fontWeight: "bold" }}>Low</small>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
const mapStateToProps = state => ({
    TicketState: state.ticket,
})
function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(CurrentPriority);